import * as React from "react";
const SvgFavorite = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.28,2V21.57A.42.42,0,0,0,4,21.9l8-6.71a.4.4,0,0,1,.54,0L20,21.86a.42.42,0,0,0,.7-.33V2Z" }));
export default SvgFavorite;
